import { useMemo } from 'react';
import { useIntl } from 'react-intl';

/** Category ids that exist in the catalog but should not drive dynamic section titles (e.g. "More Other events"). */
const EXCLUDED_CATEGORY_IDS = new Set(['Other']);

export const useLocalizedCategory = (category?: string): string | undefined => {
  const { formatMessage, messages } = useIntl();

  return useMemo(() => {
    if (!category || EXCLUDED_CATEGORY_IDS.has(category)) {
      return undefined;
    }

    if (!Object.prototype.hasOwnProperty.call(messages, category)) {
      return undefined;
    }

    return formatMessage({ id: category });
  }, [category, formatMessage, messages]);
};
